module.exports = __webpack_public_path__ + "static/media/hioki.45f8e89e.png";